import { Component } from "react"
import NextHead from "next/head"
import setDataLayer from "../../internal/google/datalayer"

class GoogleTagManager extends Component {
	shouldComponentUpdate(nextProps) {
		return nextProps.page === this.props.page
	}

	render() {
		const { dataStore, statusCode, page } = this.props
		let datalayerObj = {}

		if (typeof dataStore == "undefined" || dataStore == "" || statusCode !== 200) return null

		if (process.browser) {
			const dataStoreObj = {
				data: dataStore,
				page,
			}
			// Datalayer GTM Push
			datalayerObj = setDataLayer(dataStoreObj, true)
		}

		return (
			process.browser && (
				<NextHead>
					<script
						async
						dangerouslySetInnerHTML={{
							__html: `
							dataLayer = [${JSON.stringify(datalayerObj)}];
                    		(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
							new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
							j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
							'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
							})(window,document,'script','dataLayer','GTM-WK2N7MN');
						`,
						}}
					/>
				</NextHead>
			)
		)
	}
}

GoogleTagManager.defaultProps = {
	statusCode: 200,
}

export default GoogleTagManager
